<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <cb-vertical-navigation class="dark bg-slate-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="false">
    <!-- Navigation header hook -->
    <ng-container bxVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center h-20 pt-6 px-8">
        <img class="w-24" src="assets/images/logo/logo-blanco.png">
      </div>
  
    </ng-container>
  </cb-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 sticky top-0 z-50">
  <!-- Header -->

  <div class="fixed flex flex-col w-full pt-3 px-4 z-50 shadow bg-card print:hidden">
    <!-- Primera fila (Navbar) -->
    <div class="flex items-center w-full gap-0">
    
      <ng-container *ngIf="!isScreenSmall">
        <!-- Logo -->
        <a [routerLink]="['/']">
          <div class="flex items-center mx-2 lg:mr-8">
            <div class="hidden lg:flex">
              <img class="dark:hidden w-24" src="assets/images/logo/logo-color.png" />
              <img class="hidden dark:flex w-24" src="assets/images/logo/logo-color.png" />
            </div>
            <img class="flex lg:hidden w-8" src="assets/images/logo/logo-color.png" />
          </div>
        </a>
        
        <!-- Horizontal navigation -->
        <cb-horizontal-navigation class="mr-2 self-end" [name]="'mainNavigation'" [navigation]="navigation.horizontal">
        </cb-horizontal-navigation>
      </ng-container>
      <!-- Navigation toggle button -->
      <ng-container *ngIf="isScreenSmall">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
      </ng-container>
      <!-- Componentes del navbar -->
      <div class="flex items-center pl-2 ml-auto space-x-2">
        <span class="text-xl font-medium  color-blue"> {{enviromentLabel}}</span>
        <home-menu-cb></home-menu-cb>
        <notifications></notifications>
        <config-menu-cb></config-menu-cb>
        <executive></executive>
        <user></user>
      </div>
    </div>

    <!-- Segunda fila (Nuevo div en otra row) -->
    <div class="flex w-full justify-end px-2 -mt-2 text-lg font-medium color-blue">
      {{clientName}} - {{maskedContract}}
    </div>
  </div>
  <!-- Content -->
  <div class="flex flex-col flex-auto w-full">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->


  <div *ngIf="!hideFooter" class="text-center">
    <bx-footer></bx-footer>
  </div>

  <div class="row px-3 py-0.5 text-base">
    <div class="col-6 text-left"> Casa de Bolsa &copy; {{currentYear}} </div>
    <div class="col-6 text-right">{{enviromentLabel}} {{version}} </div>
  </div>

</div>